// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25MZ-","col":"styles_col__3Hcsp","actions":"styles_actions__iMKCC","conflict":"styles_conflict__2mwub"};